// AUTH
export const LOGIN = "LOGIN";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const REGISTER = "REGISTER";
export const REGISTER_FAILURE = "REGISTER_FAILURE";
export const LOGOUT = "LOGOUT";

export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_PROFILE_FAILURE = "UPDATE_PROFILE_FAILURE";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const UPDATE_PASSWORD_FAILURE = "UPDATE_PASSWORD_FAILURE";

// DATA
export const FETCH_DATA = "FETCH_DATA";

export const POST_DATA = "POST_DATA";
export const POST_DATA_FAILURE = "POST_DATA_FAILURE";

export const UPDATE_DATA = "UPDATE_DATA";
export const UPDATE_DATA_FAILURE = "UPDATE_DATA_FAILURE";

export const DELETE_DATA = "DELETE_DATA";
export const DELETE_DATA_FAILURE = "DELETE_DATA_FAILURE";
